import {createElement, Component, PropTypes} from 'rlink-react';
import {LANGUAGE_LABELS} from 'rlink-regions/constants';
import {FormattedMessage} from 'react-intl';

export default function getLabelFromLanguage (languageCode) {
  return (languageCode in LANGUAGE_LABELS)
       ? LANGUAGE_LABELS[languageCode]
       : <FormattedMessage
         id="ui.text.info.OTHER_LANGUAGE"
         defaultMessage="Other"
         description="Generic label for unrecognized languages" />;
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getLabelFromLanguage.jsx